
import { AssetCategory } from "../models/generics";
import client from "./axios";

const categoriesUrl = `${window.__env.GATEWAY_URL}/v1/categories`;

export const Categories = {
  getCategories: (params?: URLSearchParams) => client.get<AssetCategory[]>(categoriesUrl, { params }),
  getCategory: (id: number) => client.get<AssetCategory>(`${categoriesUrl}/${id}`),
  createCategory: (body: AssetCategory) => client.post(categoriesUrl, body),
  updateCategory: (id: number, body: AssetCategory) => client.put(`${categoriesUrl}/${id}`, body),
  deleteCategory: (id: number) => client.delete(`${categoriesUrl}/${id}`),
  getCategoriesTargets: () => client.get<string[]>(`${categoriesUrl}/targets`),
}